import { derived } from 'svelte/store'
import temaer, { DEFAULT_TEMA } from '../components/fargetema/temaer'
import { kategorier } from './kategorier'
import { currentRoute } from './router'

export const fargetema = derived([currentRoute, kategorier], ([$route, $k]) => {
  let temaId = DEFAULT_TEMA
  if ($route.params?.slug != null) {
    temaId = $k.find((k) => k.slug === $route.params.slug).fargetema
  }

  return temaer[temaId]
})
